import React from 'react';
import Header from '../components/header';
import Footer from '../components/footer';
import HomePage from './HomePage';
const MainScreen = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div style={{width:'100%',height:'100vh'}}>
       <Header/>
        <br></br>
        <br></br>
       <HomePage />
        <br></br>
        <br></br>
       <Footer/>
    </div>
  );
};

export default MainScreen;
